/** Scope counts / submits only when checked and (no elements, or ≥1 element selected). */
export const scopeHasSelectedElements = (scope, draft) => {
  if (!draft?.scopes?.[scope.scope_id]) return false;
  const elements = scope.elements || [];
  if (!elements.length) return true;
  return elements.some(e => draft.elements[e.id]);
};

/** Scope IDs that match what the review screen includes (excludes checked-but-empty scopes). */
export const selectedScopeIdsFromDraft = (trades, draft) => {
  const ids = [];
  (trades || []).forEach(trade => {
    (trade.scopes || []).forEach(scope => {
      if (scopeHasSelectedElements(scope, draft)) ids.push(scope.scope_id);
    });
  });
  return ids;
};

/**
 * Modifier IDs still belonging to the submission: scope modifiers on selected scopes,
 * plus trade modifiers for trades that still have ≥1 selected scope.
 */
export const selectedModifierIdsFromDraft = (trades, draft) => {
  const ids = new Set();
  (trades || []).forEach(trade => {
    const selectedScopes = (trade.scopes || []).filter(sc => scopeHasSelectedElements(sc, draft));
    if (!selectedScopes.length) return;
    selectedScopes.forEach(sc => {
      (sc.modifiers || []).forEach(m => {
        if (m?.id) ids.add(m.id);
      });
    });
    (trade.trade_modifiers || []).forEach(m => {
      if (m?.id) ids.add(m.id);
    });
  });
  return ids;
};
